__turbopack_context__.v({
  "checkbox": "FilterCheckbox-module-scss-module__8T-v-a__checkbox",
  "checkmark": "FilterCheckbox-module-scss-module__8T-v-a__checkmark",
  "checkmarkWrapper": "FilterCheckbox-module-scss-module__8T-v-a__checkmarkWrapper",
  "input": "FilterCheckbox-module-scss-module__8T-v-a__input",
  "label": "FilterCheckbox-module-scss-module__8T-v-a__label",
  "root": "FilterCheckbox-module-scss-module__8T-v-a__root",
});
